// extracted by mini-css-extract-plugin
module.exports = {"not_found":"sg-jg-mapping-to-role_not_found__3eWXS"};